import { render, staticRenderFns } from "./ViewAtividadeColaborador.vue?vue&type=template&id=3fc32102"
import script from "./ViewAtividadeColaborador.vue?vue&type=script&lang=js"
export * from "./ViewAtividadeColaborador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports